<template>
<div>


   <div class="wrap" v-if="piece">
     <!-- <AdminHeader /> -->
  <div class="card squeeze">

    <div class="optional-header">
        <div v-if ="piece.vidId" class="thumbnail"><img src= "/icon-4.png" alt="logo"></div>
        <div v-else-if="piece.category === 'about'" class="thumbnail"><img src="/icon-3.png" alt="logo"></div>
        <div v-else class="thumbnail"><img src="/icon-1.png" alt="logo"></div>

      <div class="primary-title">
        <div class="title">{{ piece.series }}</div>
        <div class="subhead">{{ piece.skill }}</div>
      </div>

    </div>

    <b-btn class="edit" v-b-modal.modalEditForm v-if="userIsAuthenticated && editable !== false"><i class="fas fa-3x fa-edit"></i></b-btn>
      <b-alert show variant="primary" class="lert" dismissible v-if="edited" style="margin:0;">
        Piece has been updated <b>&rArr;</b>
      </b-alert>
    <template v-if="!piece.vidId && !piece.file">
      <div class="media media-16-9">
        <!-- <img :src="piece.imageUrl"> -->
        <img :src="piece.imageUrl">
      </div>
    </template>
    <template v-if="!piece.vidId && piece.file">
      <div style="min-height:100vh;">
        <object class="tall" :data="piece.file" type="application/pdf" width="80%" height="100vh!important">
          <iframe :src="piece.file" width="80%" height="100%vh!important" style="border: none; text-align:center;">
            This browser does not support PDFs. Please download the PDF to view it: 
            <a :href="piece.file">Download PDF</a>
          </iframe>
        </object>
      </div>
    </template>
    <template v-if="piece.vidId">
    <div class="vidWrapper">
         <iframe :src="`https://www.youtube.com/embed/${piece.vidId}?autoplay=1`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    </template>
    <div class="card-content">
      <div class="head">
        {{ piece.title }}
     <!-- {{ $route.params.id }}  -->
      </div>
    <section class="supporting-text" v-html="piece.description">{{ piece.description }}</section>
  </div>
    <!-- <div class="actions"></div> -->
  </div>
      <!-- Modal -->
    <app-edit-form :piece = 'piece' :categoryOptions='categoryOptions' :seriesOptions='seriesOptions' :skillOptions='skillOptions' @pieceDeleted='deleted = true' @pieceEdited='edited = true' @closeIt="deleted = false, edited = false"></app-edit-form>
  </div>
    <b-alert show variant="primary" class="lert" dismissible v-if="deleted">
			Piece has been deleted <b>&rArr;</b>
		</b-alert>
</div>  
</template>

<script>
import { addMixin } from '../AddMixin'

export default {
data() {
  return {
    deleted: false,
    edited: false,
  }
},
	mixins: [addMixin],
  props: ['piece', 'editable' ],
  computed: {
    userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    loading () {
      return this.$store.getters.loading
    },
    
  /* eslint-disable */
    // pickIcon() {
    //   switch (this.piece.category) {
    //     case 'sculpture':
    //     return  '/icon-1.png'
    //     break;
    //     case 'blender':
    //     return  '/icon-2.png'
    //     break;        
    //     case 'image':
    //     return '/icon-3.png'
    //     break;
    //   }
    // }
  }
}
</script>